import React from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import { useExtensionsI18n } from '../i18n/provider'

interface SetActiveStateDialogProps {
  isOpen: boolean
  onClose: () => void
  targetActive: boolean
  displayName: string
  onConfirm: () => void
  isPending: boolean
}

export const SetActiveStateDialog = React.memo<SetActiveStateDialogProps>(
  ({ isOpen, onClose, targetActive, displayName, onConfirm, isPending }) => {
    const { text } = useExtensionsI18n()
    const action = targetActive
      ? text('extensions.row.activate', 'Activate').toLowerCase()
      : text('extensions.row.deactivate', 'Deactivate').toLowerCase()

    return (
      <ConfirmDialog
        open={isOpen}
        onClose={onClose}
        title={
          targetActive
            ? text(
                'extensions.activeStateDialog.activateTitle',
                'Activate extension',
              )
            : text(
                'extensions.activeStateDialog.deactivateTitle',
                'Deactivate extension',
              )
        }
        description={text(
          'extensions.activeStateDialog.body',
          'You are about to {{action}} {{displayName}}, which will cause all devices using this extension as the Primary Line Extension to be rebooted.',
          {
            action,
            displayName:
              displayName ||
              text('extensions.activeStateDialog.unnamedLine', 'Unnamed Line'),
          },
        )}
        confirmLabel={
          targetActive
            ? text('extensions.activeStateDialog.setActive', 'Set active')
            : text('extensions.activeStateDialog.setInactive', 'Set inactive')
        }
        cancelLabel={text('extensions.common.cancel', 'Cancel')}
        confirmColorPalette={targetActive ? 'success' : 'warning'}
        isLoading={isPending}
        maxWidth="480px"
        onConfirm={onConfirm}
      >
        {text(
          'extensions.activeStateDialog.confirmPrompt',
          'Are you sure you want to continue?',
        )}
      </ConfirmDialog>
    )
  },
)
